/** @format */
import { ChangeDetectionStrategy, Component, computed, inject, Input, ViewEncapsulation } from '@angular/core';
import { Education } from 'common-typescript/types';
import { PLAN_ACTIONS_SERVICE_INJECTION_TOKEN, PlanActionsService } from '../../plan/plan-actions-service/plan-actions.service';
import { EducationStateObject } from '../../service/plan-state.service';
import { PlanStructureContext } from '../plan-structure-context';

@Component({
    selector: 'sis-plan-structure-education',
    templateUrl: './plan-structure-education.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureEducationComponent {
    @Input({ required: true }) education: Education;

    headingLevel: number = 2;

    private readonly planActionsService: PlanActionsService = inject(PLAN_ACTIONS_SERVICE_INJECTION_TOKEN);
    private readonly planStructureContext = inject(PlanStructureContext);

    protected readonly educationStateObject = computed<EducationStateObject | undefined>(
        () => this.planStructureContext.planStateObject()?.education,
    );

    openModule() {
        this.planActionsService.openModule(this.education);
    }
}
